"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabBackwardsOneColumn = exports.tabForwardOneColumn = exports.updateLayoutAlignment = exports.tidyColumns = exports.initialiseWithColumns = exports.updateLayoutPadding = exports.updateLayoutGap = exports.cloneLayoutColumn = exports.removeLayoutColumn = exports.moveLayoutColumn = exports.addLayoutColumnAtIndex = exports.addLayoutColumn = exports.resizeLayoutColumn = void 0;
var slate_1 = require("slate");
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var CalculateColumnWidths_1 = require("../Widgets/Layout/CalculateColumnWidths");
var Layout_1 = require("../WidgetRegistry/Widgets/Layout");
var EvenlyDistributeColumns_1 = require("../Widgets/Layout/EvenlyDistributeColumns");
var Utils_1 = require("../Utils");
var resizeLayoutColumn = function (editor, path, _a) {
    var columnIndex = _a.columnIndex, distance = _a.distance;
    var _b = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _b[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var leftColumnData = data.columns[columnIndex];
    var rightColumnData = data.columns[columnIndex + 1];
    (0, tiny_invariant_1.default)(!!leftColumnData, "no data for left column");
    (0, tiny_invariant_1.default)(!!rightColumnData, "no data for right column");
    leftColumnData.width += distance;
    rightColumnData.width -= distance;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.resizeLayoutColumn = resizeLayoutColumn;
var addLayoutColumn = function (editor, path) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var startingColumnWidths = data.columns.map(function (col) { return col.width; });
    data.columns = (0, CalculateColumnWidths_1.getColumnWidths)({ startingColumnWidths: startingColumnWidths, operation: "add" });
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.insertNodes(editor, (0, Layout_1.createLayoutColumnNode)(), {
            at: __spreadArray(__spreadArray([], __read(path), false), [data.columns.length - 1], false),
        });
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    });
};
exports.addLayoutColumn = addLayoutColumn;
var addLayoutColumnAtIndex = function (editor, path, addColumnAtIndex) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var startingColumnWidths = data.columns.map(function (col) { return col.width; });
    data.columns = (0, CalculateColumnWidths_1.getColumnWidths)({ startingColumnWidths: startingColumnWidths, operation: "add", columnIndex: addColumnAtIndex });
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.insertNodes(editor, (0, Layout_1.createLayoutColumnNode)(), {
            at: __spreadArray(__spreadArray([], __read(path), false), [addColumnAtIndex], false),
        });
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    });
};
exports.addLayoutColumnAtIndex = addLayoutColumnAtIndex;
var moveLayoutColumn = function (editor, path, currentColumnIndex, newColumnIndex) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var columnDataToMove = data.columns.splice(Math.max(currentColumnIndex, newColumnIndex), 1)[0];
    (0, tiny_invariant_1.default)(!!columnDataToMove, "no column data at index ".concat(Math.max(currentColumnIndex, newColumnIndex)));
    data.columns.splice(Math.min(currentColumnIndex, newColumnIndex), 0, columnDataToMove);
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.moveNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [currentColumnIndex], false), to: __spreadArray(__spreadArray([], __read(path), false), [newColumnIndex], false) });
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    });
};
exports.moveLayoutColumn = moveLayoutColumn;
var removeLayoutColumn = function (editor, path, columnIndex) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var startingColumnWidths = data.columns.map(function (col) { return col.width; });
    data.columns = (0, CalculateColumnWidths_1.getColumnWidths)({ startingColumnWidths: startingColumnWidths, operation: "remove", columnIndex: columnIndex });
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [columnIndex], false) });
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    });
};
exports.removeLayoutColumn = removeLayoutColumn;
var cloneLayoutColumn = function (editor, path, columnIndex) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var startingColumnWidths = data.columns.map(function (col) { return col.width; });
    data.columns = (0, CalculateColumnWidths_1.getColumnWidths)({ startingColumnWidths: startingColumnWidths, operation: "add", columnIndex: columnIndex });
    slate_1.Editor.withoutNormalizing(editor, function () {
        var _a = __read(slate_1.Editor.node(editor, __spreadArray(__spreadArray([], __read(path), false), [columnIndex], false)), 1), targetNode = _a[0];
        var clonedColumnNode = (0, lodash_1.cloneDeep)(targetNode);
        slate_1.Transforms.insertNodes(editor, clonedColumnNode, {
            at: __spreadArray(__spreadArray([], __read(path), false), [columnIndex + 1], false),
        });
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    });
};
exports.cloneLayoutColumn = cloneLayoutColumn;
var updateLayoutGap = function (editor, path, _a) {
    var gap = _a.gap;
    var _b = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _b[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    data.gap = gap;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.updateLayoutGap = updateLayoutGap;
var updateLayoutPadding = function (editor, path, _a) {
    var padding = _a.padding;
    var _b = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _b[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    data.padding = padding;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.updateLayoutPadding = updateLayoutPadding;
var initialiseWithColumns = function (editor, path, numberOfColumns) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var emptyColumnNodes = [];
    for (var i = 0; i <= numberOfColumns - 1; i++) {
        emptyColumnNodes.push((0, Layout_1.createLayoutColumnNode)());
    }
    if (numberOfColumns === 2)
        data.columns = [{ width: 12 }, { width: 12 }];
    else if (numberOfColumns === 3)
        data.columns = [{ width: 8 }, { width: 8 }, { width: 8 }];
    else
        data.columns = [{ width: 6 }, { width: 6 }, { width: 6 }, { width: 6 }];
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.removeNodes(editor, {
            at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
        });
        slate_1.Transforms.insertNodes(editor, emptyColumnNodes, {
            at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
        });
        slate_1.Transforms.setNodes(editor, { data: data, isVoid: false }, { at: path });
    });
};
exports.initialiseWithColumns = initialiseWithColumns;
var tidyColumns = function (editor, path) {
    var _a = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _a[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    var numberOfColumns = data.columns.length;
    var columnWidths = (0, EvenlyDistributeColumns_1.evenlyDistributeColumns)(numberOfColumns);
    data.columns = data.columns.map(function (column, index) { return (__assign(__assign({}, column), columnWidths[index])); });
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.tidyColumns = tidyColumns;
var updateLayoutAlignment = function (editor, path, _a) {
    var alignment = _a.alignment;
    var _b = __read(slate_1.Editor.node(editor, path), 1), layoutWidget = _b[0];
    (0, tiny_invariant_1.default)(slate_1.Element.isElement(layoutWidget) && layoutWidget.type === "layout", "no layout found at path ".concat(path));
    var data = (0, lodash_1.cloneDeep)(layoutWidget.data);
    data.alignment = alignment;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.updateLayoutAlignment = updateLayoutAlignment;
var tabForwardOneColumn = function (editor) {
    var _a;
    var path = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.focus.path;
    if (!path)
        return;
    var layoutColumnNode = (0, Utils_1.checkAncestors)(editor, path, function (c) { return slate_1.Element.isElement(c) && c.type === "layoutColumn"; });
    if (!layoutColumnNode)
        return;
    var _b = __read(layoutColumnNode, 2), layoutColumnPath = _b[1];
    var layoutWidgetNode = (0, Utils_1.checkAncestors)(editor, layoutColumnPath, function (c) { return slate_1.Element.isElement(c) && c.type === "layout"; });
    if (!layoutWidgetNode)
        return;
    var _c = __read(layoutWidgetNode, 2), layoutWidget = _c[0], layoutWidgetPath = _c[1];
    if (!layoutWidget || !layoutColumnPath || !layoutWidgetPath)
        return;
    var numberOfColumns = layoutWidget.data.columns.length;
    var currentColumnIsLast = layoutColumnPath[layoutColumnPath.length - 1] === numberOfColumns - 1;
    if (currentColumnIsLast) {
        var lastChildRootPath = editor.children.length - 1;
        if (slate_1.Path.isCommon([lastChildRootPath], layoutWidgetPath))
            return;
        slate_1.Transforms.select(editor, slate_1.Editor.start(editor, slate_1.Path.next(layoutWidgetPath)));
    }
    else {
        slate_1.Transforms.select(editor, slate_1.Editor.start(editor, slate_1.Path.next(layoutColumnPath)));
    }
};
exports.tabForwardOneColumn = tabForwardOneColumn;
var tabBackwardsOneColumn = function (editor) {
    var _a;
    var path = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.focus.path;
    if (!path)
        return;
    var ancestors = slate_1.Path.ancestors(path, { reverse: true });
    var layoutWidget;
    var layoutWidgetPath;
    var layoutColumnPath;
    for (var i = 0; i < ancestors.length; i++) {
        if (layoutWidget && layoutColumnPath)
            break;
        var path_1 = ancestors[i];
        if (!path_1 || !path_1.length)
            continue;
        var _b = __read(slate_1.Editor.node(editor, path_1), 1), node = _b[0];
        if (!slate_1.Element.isElement(node))
            continue;
        if (!layoutColumnPath && node.type === "layoutColumn")
            layoutColumnPath = path_1;
        if (!layoutWidget && node.type === "layout") {
            layoutWidget = node;
            layoutWidgetPath = path_1;
        }
    }
    if (!layoutWidget || !layoutColumnPath || !layoutWidgetPath)
        return;
    var currentColumnIsFirst = layoutColumnPath[layoutColumnPath.length - 1] === 0;
    if (currentColumnIsFirst) {
        if (slate_1.Path.isCommon([0], layoutWidgetPath))
            return;
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, slate_1.Path.previous(layoutWidgetPath)));
    }
    else {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, slate_1.Path.previous(layoutColumnPath)));
    }
};
exports.tabBackwardsOneColumn = tabBackwardsOneColumn;
